// Generated by ReScript, PLEASE EDIT WITH CARE

import * as SWR from "../../../../node_modules/rescript-swr/lib/es6_global/src/SWR.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Markets$Showside from "../types/Markets.bs.js";
import * as Js_null_undefined from "../../../../node_modules/rescript/lib/es6/js_null_undefined.js";
import * as SWRScrapeCache$Showside from "./SWRScrapeCache.bs.js";
import * as CustomerAnimusMedicusDe$Showside from "../customers/CustomerAnimusMedicusDe.bs.js";
var lastResult = {
  contents: undefined
};
function use(market, language, storeId, smartnavApiHost, hideOutOfStock, $$fetch, productId) {
  var match = Markets$Showside.getValues(market);
  var match$1 = CustomerAnimusMedicusDe$Showside.useParseMarket(match.country, match.currency, language);
  var currency = match$1[1];
  var country = match$1[0];
  var newKey = storeId !== undefined ? smartnavApiHost + "/api/get_products?product_ids=" + productId + (hideOutOfStock ? "&in_stock=true" : "") + ("&store_id=" + storeId) + Belt_Option.mapWithDefault(country, "", function (country) {
    return "&country=" + country;
  }) + Belt_Option.mapWithDefault(currency, "", function (currency) {
    return "&currency=" + currency;
  }) + Belt_Option.mapWithDefault(match$1[2], "", function (language) {
    return "&language=" + language;
  }) : undefined;
  var findExistingReusableKey = function (param) {
    var match = lastResult.contents;
    if (match === undefined) {
      return;
    }
    var foundInLast = Caml_option.undefined_to_opt(Belt_Option.getWithDefault(match[1].data, []).find(function (p) {
      return p.id === productId;
    })) !== undefined;
    if (foundInLast) {
      return match[0];
    }
  };
  var match$2 = findExistingReusableKey(undefined);
  var key = productId === "" ? undefined : match$2 !== undefined ? match$2 : newKey;
  var match$3 = SWR.useSWR(undefined, undefined, undefined, false, Js_null_undefined.fromOption(key), Curry.__1($$fetch));
  var isValidating = match$3.isValidating;
  var data = match$3.data;
  var error = match$3.error;
  if (key !== undefined) {
    lastResult.contents = [key, {
      data: data,
      error: error,
      isValidating: isValidating
    }];
  }
  var findPartialData = function (param) {
    var scraped = SWRScrapeCache$Showside.getProductById(smartnavApiHost, currency, country, productId);
    return Belt_Option.orElse(Belt_Option.map(scraped, function (product) {
      return [product];
    }), data);
  };
  return {
    data: findPartialData(undefined),
    error: error,
    isValidating: isValidating
  };
}
export { lastResult, use };
/* SWR Not a pure module */